(function () {
  var REGION_ORDER = ['Gujarat', 'Maharashtra', 'Karnataka', 'Rajasthan', 'Madhya Pradesh', 'Other'];

  function initStoreDirectory(root) {
    var sectionId = root.id.replace('StoreDirectory-', '');
    var dataEl = document.getElementById('StoreData-' + sectionId);
    if (!dataEl) return;

    var stores;
    try {
      stores = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    stores = stores.filter(function (s) {
      return s.name;
    });

    var listEl = document.getElementById('StoreList-' + sectionId);
    var detailEl = document.getElementById('StoreDetail-' + sectionId);
    var searchEl = document.getElementById('StoreSearch-' + sectionId);

    var activeStoreId = null;
    var searchQuery = '';

    function regionSortIndex(region) {
      var idx = REGION_ORDER.indexOf(region);
      return idx === -1 ? REGION_ORDER.length : idx;
    }

    function filteredStores() {
      var q = searchQuery.trim().toLowerCase();
      var list = stores.filter(function (s) {
        if (!q) return true;
        return (s.name + ' ' + s.address).toLowerCase().indexOf(q) !== -1;
      });
      return list.sort(function (a, b) {
        var ri = regionSortIndex(a.region) - regionSortIndex(b.region);
        if (ri !== 0) return ri;
        return a.name.localeCompare(b.name);
      });
    }

    function renderList() {
      var list = filteredStores();
      listEl.innerHTML = '';

      if (!list.length) {
        var empty = document.createElement('div');
        empty.className = 'store-directory__list-empty';
        empty.textContent = 'No stores match your search.';
        listEl.appendChild(empty);
        return;
      }

      var lastRegion = null;
      list.forEach(function (s) {
        if (s.region !== lastRegion) {
          var count = list.filter(function (x) { return x.region === s.region; }).length;
          var header = document.createElement('div');
          header.className = 'store-directory__list-group-header';
          header.textContent = s.region + ' (' + count + ')';
          listEl.appendChild(header);
          lastRegion = s.region;
        }

        var item = document.createElement('div');
        item.className = 'store-directory__list-item' + (activeStoreId === s.id ? ' active' : '');
        item.setAttribute('role', 'button');
        item.setAttribute('tabindex', '0');

        var nameEl = document.createElement('p');
        nameEl.className = 'store-directory__list-item-name';
        nameEl.textContent = s.name;
        item.appendChild(nameEl);

        var addrEl = document.createElement('p');
        addrEl.className = 'store-directory__list-item-address';
        addrEl.textContent = s.address || 'Address not added yet';
        item.appendChild(addrEl);

        function select() {
          activeStoreId = s.id;
          renderList();
          renderDetail();
        }
        item.addEventListener('click', select);
        item.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            select();
          }
        });

        listEl.appendChild(item);
      });

      if (!activeStoreId || !list.some(function (s) { return s.id === activeStoreId; })) {
        activeStoreId = list[0] ? list[0].id : null;
        renderDetail();
      }
    }

    function renderDetail() {
      var store = stores.filter(function (s) { return s.id === activeStoreId; })[0];
      detailEl.innerHTML = '';

      if (!store) {
        var placeholder = document.createElement('div');
        placeholder.className = 'store-directory__detail-placeholder';
        placeholder.textContent = 'Select a store to see its location and photos.';
        detailEl.appendChild(placeholder);
        return;
      }

      if (store.mapHtml) {
        var mapWrap = document.createElement('div');
        mapWrap.className = 'store-directory__detail-map';
        mapWrap.innerHTML = store.mapHtml;
        detailEl.appendChild(mapWrap);
      } else {
        var mapMissing = document.createElement('div');
        mapMissing.className = 'store-directory__detail-map-missing';
        mapMissing.textContent = 'Map not added yet for this store';
        detailEl.appendChild(mapMissing);
      }

      var nameEl = document.createElement('h2');
      nameEl.className = 'store-directory__detail-name';
      nameEl.textContent = store.name;
      detailEl.appendChild(nameEl);

      var addrEl = document.createElement('p');
      addrEl.className = 'store-directory__detail-address';
      addrEl.textContent = store.address || 'Address not added yet';
      detailEl.appendChild(addrEl);

      if (store.images && store.images.length) {
        var imgWrap = document.createElement('div');
        imgWrap.className = 'store-directory__detail-images';
        store.images.forEach(function (img) {
          var el = document.createElement('img');
          el.src = img.thumb;
          el.alt = img.alt || store.name;
          el.loading = 'lazy';
          el.addEventListener('click', function () {
            openGallery(store.images, img.full);
          });
          imgWrap.appendChild(el);
        });
        detailEl.appendChild(imgWrap);
      }

      if (store.franchise) {
        var franchiseEl = document.createElement('div');
        franchiseEl.className = 'store-directory__detail-franchise';
        franchiseEl.textContent = 'Franchise ID: ' + store.franchise;
        detailEl.appendChild(franchiseEl);
      }
    }

    function openGallery(images, startUrl) {
      var overlay = document.querySelector('.popup-overlay');
      if (!overlay) return;
      var mainImg = overlay.querySelector('.main-img');
      var thumbs = overlay.querySelector('.thumbnail-container');
      if (mainImg) mainImg.src = startUrl;
      if (thumbs) {
        thumbs.innerHTML = '';
        images.forEach(function (img) {
          var t = document.createElement('img');
          t.src = img.thumb;
          t.alt = img.alt || '';
          t.addEventListener('click', function () {
            mainImg.src = img.full;
          });
          thumbs.appendChild(t);
        });
      }
      overlay.style.display = 'flex';
      var closeBtn = overlay.querySelector('.close-popup-btn');
      if (closeBtn) {
        closeBtn.onclick = function () {
          overlay.style.display = 'none';
        };
      }
    }

    if (searchEl) {
      searchEl.addEventListener('input', function (e) {
        searchQuery = e.target.value;
        renderList();
      });
    }

    renderList();
    renderDetail();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.store-directory').forEach(initStoreDirectory);
  });
})();
